<div class="pie-card">
  <div class="pie-header">
    <div>
      <span class="chart-eyebrow">Financeiro</span>
      <h2 class="chart-title">Movimento Financeiro</h2>
      <p class="chart-subtitle">Entradas, saídas, saldo e percentual de lucro do mês atual e dos 3 meses anteriores</p>
      <span class="chart-periodo">Período: {{ periodoLabel() }}</span>
    </div>
    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="load()" [disabled]="isLoading()">
      Atualizar
    </button>
  </div>

  @if (isLoading()) {
    <div class="state-box">
      <div class="spinner-border text-primary" role="status"></div>
      <span>Carregando resumo financeiro...</span>
    </div>
  } @else if (hasError()) {
    <div class="state-box error">
      <span>Não foi possível carregar o resumo financeiro.</span>
      <button class="btn btn-primary btn-sm" type="button" (click)="load()">Tentar novamente</button>
    </div>
  } @else if (mesAtual(); as atual) {
    <div class="row g-4">

       
       <div class="col-12 col-md-3">
        <div class="resumo-card resumo-faturado">
          <div class="resumo-icon-wrap bg-success-subtle">
            <i class="bi bi-currency-dollar text-success fs-4"></i>
          </div>
          <div class="resumo-body">
            <span class="resumo-label">Faturamento do Mês</span>
            <span class="resumo-value text-success">
              {{ atual.totalFaturado | currency:'BRL' }}
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3">
        <div class="resumo-card resumo-entrada">
          <div class="resumo-icon-wrap bg-success-subtle">
            <i class="bi bi-arrow-down-circle-fill text-success fs-4"></i>
          </div>
          <div class="resumo-body">
            <span class="resumo-label">Entradas do Mês</span>
            <span class="resumo-value text-success">
              {{ atual.totalEntrada | currency:'BRL' }}
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3">
        <div class="resumo-card resumo-saida">
          <div class="resumo-icon-wrap bg-danger-subtle">
            <i class="bi bi-arrow-up-circle-fill text-danger fs-4"></i>
          </div>
          <div class="resumo-body">
            <span class="resumo-label">Saídas do Mês</span>
            <span class="resumo-value text-danger">
              {{ atual.totalSaida | currency:'BRL' }}
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3">
        <div class="resumo-card"
             [class.resumo-saldo-positivo]="saldoPositivo"
             [class.resumo-saldo-negativo]="!saldoPositivo">
          <div class="resumo-icon-wrap"
               [class.bg-primary-subtle]="saldoPositivo"
               [class.bg-danger-subtle]="!saldoPositivo">
            <i class="bi fs-4"
               [class.bi-graph-up-arrow]="saldoPositivo"
               [class.bi-graph-down-arrow]="!saldoPositivo"
               [class.text-primary]="saldoPositivo"
               [class.text-danger]="!saldoPositivo">
            </i>
          </div>
          <div class="resumo-body">
            <span class="resumo-label">Saldo do Mês</span>
            <span class="resumo-value"
                  [class.text-primary]="saldoPositivo"
                  [class.text-danger]="!saldoPositivo">
              {{ atual.saldo | currency:'BRL' }}
            </span>
            <span class="resumo-sub"
                  [class.text-success]="saldoPositivo"
                  [class.text-danger]="!saldoPositivo">
              <i class="bi" [class.bi-arrow-up]="saldoPositivo" [class.bi-arrow-down]="!saldoPositivo"></i>
              @if (atual.percentualLucro !== null) {
                {{ atual.percentualLucro | number:'1.1-1' }}% de lucro
              } @else {
                {{ saldoPositivo ? 'Saldo positivo' : 'Saldo negativo' }}
              }
            </span>
          </div>
        </div>
      </div>

    </div>

    <div class="historico-wrap">
      <h3 class="historico-title">Histórico dos últimos meses</h3>
      <div class="table-responsive">
        <table class="table table-sm align-middle historico-table">
          <thead>
            <tr>
              <th>Mês</th>
              <th class="text-end">Faturado</th>
              <th class="text-end">Entradas</th>
              <th class="text-end">Saídas</th>
              <th class="text-end">Saldo</th>
              <th class="text-end">% Lucro</th>
            </tr>
          </thead>
          <tbody>
            @for (m of meses(); track m.dataInicio) {
              <tr [class.mes-atual]="m.mesAtual">
                <td>
                  {{ m.label }}
                  @if (m.mesAtual) {
                    <span class="badge-mes-atual">atual</span>
                  }
                </td>
                <td class="text-end text-success">{{ m.totalFaturado | currency:'BRL' }}</td>
                <td class="text-end text-success">{{ m.totalEntrada | currency:'BRL' }}</td>
                <td class="text-end text-danger">{{ m.totalSaida | currency:'BRL' }}</td>
                <td class="text-end fw-semibold"
                    [class.text-primary]="m.saldo >= 0"
                    [class.text-danger]="m.saldo < 0">
                  {{ m.saldo | currency:'BRL' }}
                </td>
                <td class="text-end">
                  @if (m.percentualLucro !== null) {
                    <span class="lucro-badge"
                          [class.lucro-positivo]="m.percentualLucro >= 0"
                          [class.lucro-negativo]="m.percentualLucro < 0">
                      <i class="bi"
                         [class.bi-arrow-up]="m.percentualLucro >= 0"
                         [class.bi-arrow-down]="m.percentualLucro < 0"></i>
                      {{ m.percentualLucro | number:'1.1-1' }}%
                    </span>
                  } @else {
                    <span class="text-muted">—</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
